import React, { Component } from 'react'
import { connect } from "react-redux";
import '../../../assets/styles/components/detail-center/comment.scss'
import postIcon from '@/assets/images/icons/light/market_comment_icon_post.png'
import uploadpictures from '@/assets/images/icons/light/market_comment_post_icon_uploadpictures.png'
import like_normal from '@/assets/images/icons/light/market_comment_icon_like_normal.png'
import like_hit from '@/assets/images/icons/light/market_comment_icon_like_hit.png'
import comment_normal from '@/assets/images/icons/light/market_comment_icon_comment_normal.png'
import comment_hit from '@/assets/images/icons/light/market_comment_icon_comment_hit.png'
import icon_more from '@/assets/images/icons/light/market_comment_icon_more.png'
import followicon from '@/assets/images/icons/light/market_comment_icon_follow.png'
import LoadingLayer from '@/components/Spinner/LoadingLayer';
import { userActions } from '@/actions/user';
import { Converter, formatFunctions,keyDownFunctions,accessibilityFunctions  } from '@/helpers/functions';
import { getSafe } from '@/helpers/global';
import { dataType } from '@/constants/data-type';
import { LOADING_TYPE } from '@/constants/app';
import { forumActions } from '@/actions/forum/forum.actions';
import { SERVICES_RESP } from '@/configurations';
import { openMarketCommentReport, openMarketCommentPost, openMarketCommentAllComment } from '@/actions/app'
class Financials extends Component {
	constructor(props) {
		super(props)
		this.state = {
			isShowcomments: false,
			isthumbsup: false,
			iscomment: "",
			isreport: false,
			PostsData: null,
			load: true,
			cid: null,
			arrangementCommentData: null,
			replyName: null,
		}
	}
	render() {
		const { language } = this.props;
		const { isShowcomments, isthumbsup, iscomment, isreport, PostsData, load, replyName } = this.state;
		return (
			<div className="Comment_assembly">
				<LoadingLayer load={load} type={LOADING_TYPE.BIG_IMG} />
				<div id="Comment-header-container" className="Comment-header-container">
					<div className="Comment-top-container" onClick={() => openMarketCommentPost(() => this.getPostList())}
					     onKeyDown={keyDownFunctions.handleEnterKeyDown(() => openMarketCommentPost(() => this.getPostList()))}
						 {...accessibilityFunctions.hasTabIndex()}>
						<img src={postIcon} />
						<div className="Comment-span-container">{language.market_comment_post}</div>
					</div>
				</div>
				<div id="Comment-centre-container" className="Comment-centre-container">
					<div id="Comment-centrefor-container" className="Comment-centrefor-container">
						{PostsData?.map((opt, index) => {
							return (
								<div id="Comment-centre-container" className="Comment-centre-container" key={opt.nid}>
									<div id="Comment-centrehead-container" className="Comment-centrehead-container">
										<div id="Comment-head-portrait" className="Comment-head-portrait Comment-item">
											<img src={ opt.account_avatar ? opt.account_avatar : uploadpictures} />
											<span className="Comment_span"> {opt?.account_nick}   </span>
										</div>
										<div id="Comment-Creation-time" className="Comment-Creation-time Comment-item">{formatFunctions.dataFormat(Number(opt.created), dataType.LONG_DATE)}</div>
										{  opt.account_id !== this.props.userInfo.id &&  ( opt.following == "N" ?
										    <div id="Comment-isconcerned" className="Comment-isconcerned Comment-item" onClick={() => this.handfollow(opt, index)} 
											     onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handfollow(opt, index))} {...accessibilityFunctions.hasTabIndex()}>
											  <img src={followicon} /><span>{language.market_comment_follow}</span>
										    </div> :
											<div id="Comment-isconcernedtwo" className="Comment-isconcernedtwo Comment-item" onClick={() => this.handunfollow(opt, index)}
											     onKeyDown={keyDownFunctions.handleEnterKeyDown(() =>this.handunfollow(opt, index))}
						                         {...accessibilityFunctions.hasTabIndex()}>
												<span>{language.market_comment_followed}</span>
											</div>)
										}
									</div>
									<div id="Comment-centrebody-container" className="Comment-centrebody-container">
										<h2>{opt.title && opt.title}</h2>
										<div className="comment_title">{opt.summary && opt.summary}</div>
										<div className="comment_imgs">
											{opt.attaches && ((opt.attaches).split(",")).map((opts, index) => {
												return(
														<div className='comment_img'  key={index} >
															<img key={index} src={opts} />
														</div>
													)
											})}
										</div>
									</div>
									<div id="Comment-centrefooter-container" className="Comment-centrefooter-container">
										<div id="Comment-centrebodyhead-container" className="Comment-centrebodyhead-container Comment-centrefooter-item" onClick={() => this.handthumbsup(opt, index)}
										      onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handthumbsup(opt, index))} {...accessibilityFunctions.hasTabIndex()}>
											{opt.like == "N" ? <img src={like_normal} /> : <img src={like_hit} />}
											<span className="Give_the_thumbs-up" style={{ color: opt.like == "Y" ? '#1996e3' : '' }} >{opt.dlike_counts}</span>
										</div>
										<div id="Comment-centrebodycenter-container" className="Comment-centrebodycenter-container Comment-centrefooter-item" >
											{opt.nid == iscomment ? 
											<img onClick={(e) => this.handcomment(e, opt)} src={comment_hit} onKeyDown={keyDownFunctions.handleEnterKeyDown((e) => this.handcomment(e, opt))}{...accessibilityFunctions.hasTabIndex()}/> : 
											<img src={comment_normal} onClick={(e) => this.handcomment(e, opt)} onKeyDown={keyDownFunctions.handleEnterKeyDown((e) => this.handcomment(e, opt))}{...accessibilityFunctions.hasTabIndex()} />}
											<span className="Comment_comment" style={{ color: opt.nid == iscomment ? '#1996e3' : '' }} >{opt.comments_count}</span>
										</div>
										<div id="Comment-centrebodyfooter-container" className="Comment-centrebodyfooter-container Comment-centrefooter-item">
											<img src={icon_more} onClick={(e) => this.handisreport(e, opt)} onKeyDown={keyDownFunctions.handleEnterKeyDown((e) => this.handisreport(e, opt))} {...accessibilityFunctions.hasTabIndex()}/>
											{opt.nid == isreport ? <div className="Report_positioning" onClick={() => openMarketCommentReport(opt.nid)}  onKeyDown={keyDownFunctions.handleEnterKeyDown(() => openMarketCommentReport(opt.nid))}{...accessibilityFunctions.hasTabIndex()}>{language.market_comment_report}</div> : <div></div>}
										</div>
									</div>
									{opt.nid == isShowcomments ?
										<div>
											<div id="Comment-cfooter-container" className="Comment-cfooter-container" onClick={e => e.stopPropagation()}
											     onKeyDown={keyDownFunctions.handleEnterKeyDown(e => e.stopPropagation())} {...accessibilityFunctions.hasTabIndex()}>
												<div className="Comment_input Comment-cfooter">
													<input placeholder={replyName ? language.market_comment_reply + ' ' + replyName : language.market_comment}  maxlength={249} ref={e => this.commentInputRef = e} onFocus={() => this.setState({ isShowcomments: opt.nid })} />
												</div>
												<div className="Comment_send Comment-cfooter" onClick={() => this.handsend(opt)} 
												     onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handsend(opt))}
											         {...accessibilityFunctions.hasTabIndex()}>{language.market_comment_send}</div>
											</div>
										</div>
										: <div></div>}
											<div id="Comment-centrecomment-container" className="Comment-centrecomment-container"  >
												{opt?.data?.rows && opt.data.rows.map((ritem, rindex) => {
													if (ritem.pid_account_id) {
														return (
															<div className='Comment-centrecomment-container-reply' key={rindex} >
																<span className='Comment-centrecomment-container-reply-name' >{ritem.account_nick + ' '}</span>
																<span className='Comment-centrecomment-container-reply-reply'>{language.market_comment_reply + ' '}</span>
																<span className='Comment-centrecomment-container-reply-name' >{ritem.pid_account_nick + ':'}</span>
																<span className='Comment-centrecomment-container-reply-content'  >{ritem.content} </span>
															</div>
														)
													} else {
														return (
															<div className='Comment-centrecomment-container-comment' key={rindex} >
																<span className='Comment-centrecomment-container-name' >{ritem.account_nick + ':'}<span className='Comment-centrecomment-container-content' >{ritem.content}</span></span>
																<div className='Comment-centrecomment-container-reply-reply' onClick={() => this.handleReplyButton(ritem, rindex,opt)}  
																      onKeyDown={keyDownFunctions.handleEnterKeyDown(() => this.handleReplyButton(ritem, rindex,opt))}
																	  {...accessibilityFunctions.hasTabIndex()}>{language.market_comment_reply} </div>
															</div>
														)
													}
												})}
											</div>
											{  opt?.data?.rows?.length >= 5 &&  <div  className='Comment-centrecomment-container-view-more'  onClick={() => openMarketCommentAllComment(opt, () => this.getPostList(),)}>{language.market_comment_view_more}</div>}
									<div id="Comment-last-container" className="Comment-last-container"></div>
								</div>
							)
						})}
					</div></div>
			</div>
		)
	}
	componentDidMount() {
		const { marketParams } = this.props;
		const { marketID, stockCode } = marketParams;
		this.props.innerRef(this)
		this.getPostList();
		document.addEventListener('click', this.hiddenButton)
	}
	componentDidUpdate(preProps ){
		const { language , marketParams } = this.props
		if (marketParams && preProps.marketParams !== marketParams) {
			this.setState({cid:null,replyName:null,
				isShowcomments:null,iscomment:null,
				isreport:null},()=>{
                this.getPostList()
            })
		}
	}
	componentWillUnmount() {
		document.removeEventListener('click', this.hiddenButton)
	}

	handleReplyButton = (ritem, rindex,opt) => {
		this.setState({ cid: ritem.cid,
			 replyName: ritem.account_nick,
			 isShowcomments:opt.nid,
			 iscomment:opt.nid
			}, () => {
		})
	}

	hiddenButton = () => {
		this.setState({
			isreport: '',
			//  iscomment: '', isShowcomments: ""
		})
	}
	handsend = (opt) => {
		const { cid } = this.state
		if(!this.commentInputRef.value) return
		if (cid) {
			const params = {
				cid: cid,
				body: this.commentInputRef.value,
			}
			this.commentInputRef.value = ''
			this.setState({ load: true })
			this.props.replyComment(params, res => {
				if (res) {
					this.setState({ isShowcomments: "", load: false, iscomment: "", cid: null, replyName: null })
					this.getPostList()
				}
			})
		} else {
			const params = {
				nid: opt.nid,
				body: this.commentInputRef.value
			}
			this.commentInputRef.value = ''
			this.setState({ load: true })
			this.props.writeComment(params, res => {
				if (res) {
					this.setState({ isShowcomments: "", load: false, iscomment: "", cid: null, replyName: null })
					this.getPostList()
				}
			})
		}
	}


	handfollow = (opt, index) => {
		const { PostsData } = this.state
		const { userInfo } = this.props;
		const { id } = userInfo;
		const params = { id: id, follow_id: opt.account_id }
		this.setState({load:true})
		this.props.postSubscribeList(params, res => {
			if (res) {
				this.getPostList()
			}
		})
	}
	handunfollow = (opt, index) => {
		const { PostsData } = this.state
		const { userInfo } = this.props;
		const { id } = userInfo;
		const params = { id: id, follow_id: opt.account_id }
		this.setState({load:true})
		this.props.postUnsubscribeList(params, res => {
			if (res) {
				// PostsData[index].following = 'N'
				// this.setState({ PostsData,load:false })
				this.getPostList()
			}
		})
	}
	handthumbsup = (opt, index) => {
		let { PostsData } = this.state
		const params = {
			id: opt.nid,
			name: "node_posts_like",
			switch: opt.like === 'Y' ? 'N' : 'Y',
			versiontype: 'Services-Flag-Toggle-Version',
			versionnum: '1.1'
		}
		this.props.toggleFlag(params, res => {
			if (res.status === SERVICES_RESP.STATUS_OK) {
				PostsData[index].like = params.switch
				if (params.switch == 'Y') {
					PostsData[index].dlike_counts += 1
				} else {
					PostsData[index].dlike_counts -= 1
				}
				this.setState({ PostsData })
			}
		})
	}
	handcomment = (e, opt) => {
		const { iscomment } = this.state;
		e.stopPropagation()
		if (iscomment == opt.nid) {
			this.setState({ iscomment: "", isShowcomments: "", cid: null, replyName: null })
		} else {
			this.setState({
				iscomment: opt.nid,
				isShowcomments: opt.nid,
				cid: null,
				replyName: null
			})
		}
	}
	handisreport = (e, opt) => {
		const { isreport } = this.state;
		e.stopPropagation()
		if (isreport == opt.nid) {
			this.setState({ isreport: "" })
		} else {
			this.setState({ isreport: opt.nid })
		}
	}

	getPostList = () => {
		const { userInfo, language, marketParams } = this.props;
		const { id } = userInfo;
		if (id) {
			this.setState({ load: true })
			const params = {
				size:50,
				uuid: id,
				versiontype: "Services-Customer-Posts-Version",
				versionnum: '1.1',
				instrument: marketParams.stockCode + ":" + marketParams.marketID
			}
			this.props.getCommentPostList(params, res => {
				if (res) {
					this.setState({ PostsData: res.rows, load: false },()=>{
					})
				}
			})
		}
	}
}


export default connect(
	(state) => ({
		language: state.app.language,
		mdsToken: state.trade.mdsToken,
		marketParams: state.trade.marketParams,
		userInfo: state.user.userInfo,
	}),
	(dispatch) => ({
		getCommentPostList: (p, c) => dispatch(userActions.getPostListAction(p, c)),
		postSubscribeList: (p, c) => dispatch(userActions.postSubscribeAction(p, c)),
		postUnsubscribeList: (p, c) => dispatch(userActions.postUnsubscribeAction(p, c)),
		toggleFlag: (p, res) => dispatch(forumActions.toggleFlagAction(p, res)),  //点赞
		writeComment: (p, res) => dispatch(forumActions.writeCommentAction(p, res)),
		replyComment: (p, c) => dispatch(userActions.getMarketCommentReplyAction(p, c))
	})
)(Financials);

